export default __webpack_public_path__ + "static/media/tftlinkIcon.c450149a.svg";